<template>
  <div class="product-template __donate __limited-edu __limited-edu--icap">
    <div class="container pd-sm-0">
      <div class="col-md-push-3 col-md-6">
        <h1 data-v-1f20e9ef="" class="text-center mb-20">
          <img src="/static/img/limited-edu/logo-icap-tcfe.png" srcset="/static/img/limited-edu/logo-icap-tcfe@2x.png" alt="Limited Education" class="pd-15 ma-auto d-block" />
        </h1>
      </div>
    </div>


    <div class="container pd-sm-0">
      <div class="col-md-push-1 col-md-10">
        <div class="product product--inline">
          <div class="product__block--form ">
            <div class="radius block shadow ">
              <product-donate-choice
              :show-donate-type="true"
              :product="product"
              v-model="product.price"
              ref="donateChoice"
              classes="col-1-5" />

              <div class="form__wrapper mt-15 mb-15">

                <!-- NO Option -->
                <div class="form__section">
                  <label class="form__radio-lg">
                    ไม่ต้องการรับเสื้อ
                    <input class="" type="radio" name="optionsRadios" value="" v-model="attributes.info.rewardProduct"  />
                    <span class="checkmark"></span>
                  </label>
                </div><!-- end form section -->

                <!-- Take Reward -->
                <div class="form__section">
                  <label class="form__radio-lg" :class="{disable: isRewardDisabled}">
                    {{ rewardTitleText }} <br />
                    <span class="small">พร้อมจัดส่งให้ถึงบ้านภายใน 30 วันหลังทำการบริจาค</span>
                    <input class="" type="radio" name="optionsRadios" :value="tshirtProductName" :disabled="isRewardDisabled" v-model="attributes.info.rewardProduct" />
                    <span class="checkmark"></span>
                  </label>

                  <transition name="slide-down">
                    <div class="slide-down-wrapper" :class="{disable: isRewardDisabled}" v-show="isTakeReward">
                      <div class="form__section block-third slide-down-item">
                        <div class="form__item--lmt-deu">
                          <div class="row">
                            <div class="col-sm-12 col-md-6">

                              <!-- BEGIN: Thumbnail -->
                              <div
                                class="current-thumbnail-wrapper"
                                @click="showImage(currentThumbnailImage)"
                              >
                                <img :src="currentThumbnailImage" alt="Limited Education" class="ma-auto d-block pd-15" />
                              </div>

                              <div class="row mb-10">
                                <div
                                  v-for="(thumbnail, i) in thumbnailImages"
                                  :key="i"
                                  class="col-sm-4 col-md-4"
                                >
                                  <div
                                    class="thumbnail-wrapper"
                                    :class="{ selected: thumbnail === currentThumbnailImage }"
                                    @click="changeThumbnail(thumbnail)"
                                  >
                                    <img :src="thumbnail" alt="Limited Education" class="ma-auto d-block" />
                                  </div>
                                </div>
                              </div>
                              <!-- END: Thumbnail -->

                            </div>
                            <div class="col-sm-12 col-md-6">

                              <!-- BEGIN: Select Size Option -->
                              <div>
                                <div class="d-flex justify-content-between align-items-center mb-10">
                                  <strong>เลือกขนาดเสื้อและจำนวน</strong>
                                  <strong class="choice-selected">{{ selectedSizeCount }}/{{ rewardCount }}</strong>
                                </div>
                                <div class="wrapper-size-choice">

                                  <div
                                    v-for="sizeOption in sizeOptions"
                                    :key="sizeOption.text"
                                    class="size-choice"
                                    :class="{
                                      active: hasSelectedSize(sizeOption.text),
                                      'only-one': rewardCount === 1
                                    }"
                                    @click="selectSize(sizeOption.text)"
                                  >
                                    <label class="">{{ sizeOption.text }}</label>
                                    <div class="text-remark">{{ sizeOption.description }}</div>
                                    <div class="number-field">
                                      <a href="#" @click.prevent.stop="decreaseSize(sizeOption.text)">-</a>
                                      <span class="number-item">{{ selectedSize[sizeOption.text] }}</span>
                                      <a href="#" @click.prevent.stop="increaseSize(sizeOption.text)">+</a>
                                    </div>
                                  </div>

                                  <div class="alert alert--error" v-if="error.rewardConfigSize">{{ error.rewardConfigSize }}</div>

                                </div>
                              </div>
                              <!-- END: Select Size Option -->

                            </div>
                          </div>
                        </div>
                      </div> <!-- end form_section -->
                    </div>
                  </transition>
                </div><!-- end form section -->

              </div><!-- end form wrapper -->

              <donor-info v-model="attributes.info.name"
                class="pt-15" />

              <page-selector
                :product="product"
                v-model="attributes.page"
                v-show="false" />

              <product-cart-action
                :product="product"
                :attributes="attributes"
                :initialQuantity="1"
                :addToCartButton="false"
                :buyNowButton="false"
                :style="{margin:0}"
                ref="cartAction" />

              <div class="text-center">
                <button type="button" class="btn btn--purple btn--default" @click.prevent="donate">บริจาค</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DonorInfo from '@/components/DonorInfo'
  import PageSelector from '@/components/PageSelector'
  import ProductCartAction from '@/components/ProductCartAction'
  import ProductDonateChoice from '@/components/ProductDonateChoice'

  export default {
    name: 'ProductTemplateICAP',

    components: {
      DonorInfo,
      PageSelector,
      ProductCartAction,
      ProductDonateChoice
    },

    props: {
      title: { type: String, default: 'บริจาค' },
      product: { type: Object, required: true }
    },

    data () {
      return {
        tshirtProductName: 'T-Shirt',
        attributes: {
          info: {
            name: '',
            rewardProduct: ''
          },
          page: ''
        },
        error: {
          rewardConfigSize: false
        },
        selectedSize: {},
        currentThumbnailImage: ''
      }
    },

    computed: {
      rewardTitleText () {
        if (this.rewardCount > 0) {
          return `รับเสื้อยืดรุ่นพิเศษ "ไทยวีอาย" ${this.rewardCount} ตัว`
        }
        return 'รับเสื้อยืดรุ่นพิเศษ "ไทยวีอาย"'
      },

      rewardCount () {
        const divider = 500
        return Math.floor(this.product.price / divider)
      },

      isRewardDisabled () {
        return this.product.price < 500
      },

      isTakeReward () {
        return this.attributes.info.rewardProduct === this.tshirtProductName
      },

      selectedSizeCount () {
        return Object.values(this.selectedSize).reduce((prev, curr) => {
          return prev + curr
        }, 0)
      },

      sizeOptions () {
        // SS:รอบอก 34 นิ้ว,S:รอบอก 36 นิ้ว,M:รอบอก 38 นิ้ว,L:รอบอก 40 นิ้ว,XL:รอบอก 42 นิ้ว,XXL:รอบอก 44 นิ้ว
        return this.product.meta.donation_tshirt_size.split(',').map(row => {
          const [ text, description ] = row.split(':')
          return { text, description }
        })
      },

      thumbnailImages () {
        return this.product.images
      }
    },

    created () {
      this.initSelectedSize()
      this.initThumbnail()
    },

    methods: {
      initSelectedSize () {
        const selectedSize = {}
        for (const sizeOption of this.sizeOptions) {
          selectedSize[sizeOption.text] = 0
        }
        this.selectedSize = selectedSize
      },

      initThumbnail () {
        this.currentThumbnailImage = this.thumbnailImages[0]
      },

      validate () {
        this.error.rewardConfigSize = false

        let valid = true
        const {info} = this.attributes

        // Not select reward option.
        if (info.rewardProduct === null) {
          this.error.rewardProduct = true
          valid = false
        } else if (info.rewardProduct === this.tshirtProductName) {
          // Validate size selection.
          if (this.selectedSizeCount === 0) {
            this.error.rewardConfigSize = 'กรุณาเลือกขนาดเสื้อ'
            valid = false
          // } else if (this.selectedSizeCount < this.rewardCount) {
          //   this.error.rewardConfigSize = 'กรุณาเลือกขนาดเสื้อให้ครบ'
          //   valid = false
          } else if (this.selectedSizeCount > this.rewardCount) {
            this.error.rewardConfigSize = 'เลือกขนาดเสื้อเกินจำนวน'
            valid = false
          }
        }

        return valid
      },

      async donate () {
        if (!this.$refs.donateChoice.validate()) {
          return
        }

        if (!this.validate()) {
          return
        }

        // Update reward info.
        if (this.attributes.info.rewardProduct === this.tshirtProductName) {
          // Copy info to update size before re-assign back.
          const info = JSON.parse(JSON.stringify(this.attributes.info))

          // Update size (selected only).
          Object.keys(this.selectedSize).forEach(size => {
            const count = this.selectedSize[size]
            if (count > 0) {
              info[size] = count
            }
          })

          // Re-assign info back to attributes.
          this.attributes.info = info
        }

        // Clear previous cart info.
        await this.$store.dispatch('clearCart')

        // Add donation product to cart and go to checkout.
        this.$refs.cartAction.buyNow()
      },

      showImage (src) {
        this.$modal.show({
          text: `<img class="img-enlarged" src="${src}" />`,
          okButtonText: 'ปิด'
        })
      },

      changeThumbnail (src) {
        this.currentThumbnailImage = src
      },

      hasSelectedSize (text) {
        return this.selectedSize[text] > 0
      },

      selectSize (text) {
        if (this.rewardCount === 1) {
          // Reset all size except selected.
          this.clearSelectedSize()
        }

        // Set size to 1 if it is 0.
        if (this.selectedSize[text] === 0) {
          this.increaseSize(text)
        }
      },

      increaseSize (text) {
        if (this.selectedSizeCount < this.rewardCount) {
          this.selectedSize[text]++
        }
      },

      decreaseSize (text) {
        this.selectedSize[text]--
        if (this.selectedSize[text] < 0) {
          this.selectedSize[text] = 0
        }
      },

      clearSelectedSize () {
        Object.keys(this.selectedSize).forEach(size => {
          this.selectedSize[size] = 0
        })
      }
    },

    watch: {
      'product.price': function (amount) {
        if (!amount || amount < 500) {
          this.attributes.info.rewardProduct = ''
        } else {
          this.attributes.info.rewardProduct = this.tshirtProductName
        }
        this.clearSelectedSize()
      }
    }
  }
</script>

<style lang="scss" scoped>
  h1.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    font-size: 2em;
    font-weight: 400;
    margin-bottom: 15px;
  }

  h3.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
  }
  .block { background: #fff; }
  .btn--default {
    margin: 20px auto 10px;
  }

  .slide-down-wrapper {
    margin-top: 15px;
  }

  .current-thumbnail-wrapper {
    cursor: zoom-in;
  }

  .thumbnail-wrapper {
    border: 1px solid transparent;
    cursor: pointer;

    &.selected {
      border-color: orange;
    }
  }

  .size-choice {
    cursor: pointer;

    &.only-one {
      .number-field {
        display: none;
      }
    }

    &.active {
      border: 1px solid orange;
    }
  }
</style>



// WEBPACK FOOTER //
// icap.vue?54b1a164